import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import SwiperCore, { Scrollbar, Autoplay, SwiperOptions, Pagination, Swiper } from 'swiper';
import { ConnectionService } from '@services/connection-service';

@Component({
  selector: 'app-week2-part-one',
  templateUrl: './week2-part-one.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class Week2PartOneComponent implements OnChanges {
  carouselConfigWeeklyJourney: SwiperOptions = {
    slidesPerView: 'auto',
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
  };
  @Input('user')user:any;
  @Input('followUp')followUp:any;
  @Output('openInstructions')openInstructions:EventEmitter<string> = new EventEmitter();
  @Output('openStaticArticle1')openStaticArticle1:EventEmitter<string> = new EventEmitter();
  @Output('openStaticArticle2')openStaticArticle2:EventEmitter<string> = new EventEmitter();
  @Output('sendClickEvent') sendClickEvent: EventEmitter<string> = new EventEmitter();

  constructor(private conn: ConnectionService) {
  }
  ngOnChanges(): void {
  }
  handleInstructions(card:string):void {
    this.sendClickEvent.emit('week_2_p2_instructions');
    this.openInstructions.emit(card);
  }
  handleArticle1(card:string):void {
    this.sendClickEvent.emit('week_2_p2_tip_sunscreen');
    this.openStaticArticle1.emit(card);
  }
  handleArticle2(card:string):void {
    this.sendClickEvent.emit('week_2_p2_result_timeline');
    this.openStaticArticle2.emit(card);
  }
  handleCTA():void {
    this.sendClickEvent.emit('week_2_p2_diet_header_cta');
    this.conn.navigateToURL('https://app.cureskin.com/article/MMQlAYqq7c');
  }
}
